import styled from "@emotion/styled/macro";
import isStyledPropsValid from "utils/isStyledPropsValid";
import { Button, IconButton } from "@metacrm/metacrm-material-ui/dist/Button";
import Box from "@mui/material/Box";

export const StyledCircle = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, status }) => {
  return {
    height: "8px",
    width: "8px",
    borderRadius: "50%",
    ...(status === "sent" && {
      backgroundColor: "#36BF00",
    }),
    ...(status === "scheduled" && {
      backgroundColor: "#FFC800",
    }),
    ...(status === "draft" && {
      backgroundColor: "transparent",
      border: `1px solid #BCBCBC`,
    }),
    ...(status === "archived" && {
      backgroundColor: "#777",
    }),
  };
});

export const StyledStatusText = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, status }) => {
  return {
    marginLeft: "4px",
    textTransform: "capitalize",
    ...(status === "sent" && {
      color: theme.customColors.grey[600],
    }),
    ...(status === "scheduled" && {
      color: theme.customColors.grey[600],
    }),
    ...(status === "draft" && {
      color: "#BCBCBC",
    }),
    ...(status === "archived" && {
      color: theme.customColors.grey[600],
    }),
  };
});
